/* global jQuery google */

// eslint-disable-next-line no-unused-vars
function initMap() { }

; (function ($) {
	/*
		*  initMap
		*
		*  Will be fired when the Google Maps API has loaded, reassigns global function
		*/
	// eslint-disable-next-line no-func-assign
	initMap = function () {
		$('.google-map').each(function () {
			newMap($(this))
		})
	}

	function getAdaptedZoom(zoomLevel) {
		if ($(window).width() < 576) {
			return zoomLevel -= 2;
		} else if ($(window).width() < 769) {
			return zoomLevel -= 1;
		} else {
			return zoomLevel;
		}
	}

	const DEFAULT_BOUNDS = {
		north: 66.933465987735616,
		south: 49.09466907684661,
		west: -22.145933991390892,
		east: 10.9119244765624913,
	};

	/*
		*  render a Google Map onto the selected jQuery element
		*/
	function newMap($el) {
		var $markers = $el.find('.marker')
		var args = {
			zoom: getAdaptedZoom(parseInt($el.data('zoom'))),
			minZoom: 4,
			maxZoom: 16,
			// center: new google.maps.LatLng($el.context.dataset.centerLat, $el.context.dataset.centerLng),
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			disableDefaultUI: true,
			restriction: {
				latLngBounds: DEFAULT_BOUNDS,
				strictBounds: true,
			},
			styles: [
				{ elementType: "labels.text.fill", stylers: [{ color: "#0C365A" }] },
				{ elementType: "labels.text.stroke", stylers: [{ color: "#00000001" }] },
				{
					featureType: 'all',
					stylers: [{ saturation: 0 }, { hue: '#f0f2f5' }]
				}, {
					featureType: 'administrative',
					elementType: 'all',
					stylers: [
						{
							'visibility': 'simplified'
						}
					]
				},
				{
					featureType: 'landscape',
					elementType: 'all',
					stylers: [{ color: '#f0f2f5' }]
				},
				{
					featureType: 'road',
					stylers: [{ saturation: 0 }, { color: '#fbfcfc' }]
				},
				{
					featureType: 'transit',
					stylers: [{ visibility: 'off' }]
				},
				{
					featureType: 'road.highway',
					stylers: [{ visibility: 'off' }]
				},
				{
					featureType: 'poi',
					stylers: [{ visibility: 'off' }]
				},
				{
					featureType: 'water',
					stylers: [{ color: '#ced5dd' }, { saturation: 0 }]
				}
			]
		}
		var map = new google.maps.Map($el[0], args)
		map.markers = []
		$markers.each(function () {
			addMarker($(this), map)
		})

		centerMap(map)



		return map
	}

	/*
		*  add a marker to the selected Google Map
		*/
	function addMarker($marker, map) {
		var latlng = new google.maps.LatLng(
			$marker.attr('data-lat'),
			$marker.attr('data-lng')
		)
		var marker = new google.maps.Marker({
			position: latlng,
			map: map,
			icon: new google.maps.MarkerImage($marker.attr('data-icon'))
		})
		map.markers.push(marker)
		// if marker contains HTML, add it to an infoWindow
		if ($marker.html()) {
			var infowindow = new google.maps.InfoWindow({
				content: $marker.html()
			})
			google.maps.event.addListener(marker, 'position_changed', function () {
				infowindow.open(map, marker)
			})

			infowindow.open(map, marker);


		}
	}

	/**
		*  center the map, showing all markers attached
		*/
	function centerMap(map) {
		var bounds = new google.maps.LatLngBounds()
		// loop through all markers and create bounds
		$.each(map.markers, function (i, marker) {
			var latlng = new google.maps.LatLng(
				marker.position.lat(),
				marker.position.lng()
			)
			bounds.extend(latlng)
		})
		if (map.markers.length === 1) {
			map.setCenter(bounds.getCenter())
		} else {
			map.fitBounds(bounds)
		}
	}
})(jQuery)
